  import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchWorkoutPreferenceThunk } from "../../../src/redux/Slices/workoutPreferenceSlice";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import Loader from "../../components/Common/Loader";
import WorkoutPreferenceForm from "./WorkoutPreferenceForm";

function ClientWorkoutPreference({ selectedCoachId, selectedClientId, status }) {
  const { trans } = useCustomTranslation();
  const dispatch = useDispatch();
  const { workoutPreference, isLoading } = useSelector(
    (state) => state?.getWorkoutPreference
  );
  const [experienceOptionsList, setExperienceOptionsList] = useState([]);
  const [eqipmentOptionList, setEqipmentOptionList] = useState([]);
  const [locationOptionsList, setLocationOptionsList] = useState([]);
  const [injuriesOptionsList, setInjuriesOptionsList] = useState([]);

  useEffect(() => {
    dispatch(fetchWorkoutPreferenceThunk(selectedCoachId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedClientId]);

  useEffect(() => {
    if (workoutPreference?.equipmentList) {
      const mappedEquipmentList = workoutPreference.equipmentList.map(
        (item) => ({
          id: item.id.toString(),
          label: item.label,
        })
      );
      setEqipmentOptionList(mappedEquipmentList);
    }
    if (workoutPreference?.locationList) {
      const mappedEquipmentList = workoutPreference.locationList.map(
        (item) => ({
          id: item.id.toString(),
          label: item.label,
        })
      );
      setLocationOptionsList(mappedEquipmentList);
    }
    if (workoutPreference?.experienceLevelList) {
      const mappedEquipmentList = workoutPreference.experienceLevelList.map(
        (item) => ({
          id: item.id.toString(),
          label: item.label,
        })
      );
      setExperienceOptionsList(mappedEquipmentList);
    }

    if (workoutPreference?.injuriesList) {
      const mappedEquipmentList = workoutPreference.injuriesList.map(
        (item) => ({
          id: item.id.toString(),
          label: item.label,
        })
      );
      setInjuriesOptionsList(mappedEquipmentList);
    }
  }, [workoutPreference]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className="backgroundWhite">
      <h6 className="mt-3 ">
        {trans("ClientWorkout.workoutPreferences")}
      </h6>

      <div>
        <WorkoutPreferenceForm
          selectedClientId={selectedClientId}
          selectedCoachId={selectedCoachId}
          ExperienceOption={experienceOptionsList}
          LocationOption={locationOptionsList}
          EquipmentOption={eqipmentOptionList}
          InjuriesOption={injuriesOptionsList}
          status={status}
        />
      </div>
    </div>
  );
}

export default ClientWorkoutPreference;
